module.exports = __webpack_public_path__ + "zilky-v-obliceji_1_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/zilky-v-obliceji_1_after.jpg
// module id = 993
// module chunks = 0